<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="txbxPosition">Position</label>
                    <input id="txbxPosition" type="text" class="form-control" [(ngModel)]="target.position" name="position" />
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="txbxNeeds">Needs</label>
                    <input id="txbxNeeds" type="number" class="form-control" [(ngModel)]="target.needs" name="needs" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-4">
                <div class="form-group">
                    <label for="applicants">Applicants</label>
                    <input id="applicants" type="number" class="form-control" [(ngModel)]="target.applicants" name="applicants" />
                </div>
            </div>
            <div class="col-4">
                <div class="form-group">
                    <label for="interviews">Interviews</label>
                    <input id="interviews" type="number" class="form-control" [(ngModel)]="target.interviews" name="interviews" />
                </div>
            </div>
            <div class="col-4">
                <div class="form-group">
                    <label for="offers">Offers</label>
                    <input id="offers" type="number" class="form-control" [(ngModel)]="target.offers" name="offers" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="referrals">Referrals</label>
                    <input id="referrals" type="number" class="form-control" [(ngModel)]="target.referrals" name="referrals" />
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="screenings">Number of Screenings</label>
                    <input id="screenings" type="number" class="form-control" [(ngModel)]="target.screenings" name="screenings" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="applicationsRejected">Applications Rejected</label>
                    <input
                        id="applicationsRejected"
                        type="number"
                        class="form-control"
                        [(ngModel)]="target.applicationsRejected"
                        name="applicationsRejected"
                    />
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="applicationsUnderReview">Applications Under Review</label>
                    <input
                        id="applicationsUnderReview"
                        type="number"
                        class="form-control"
                        [(ngModel)]="target.applicationsUnderReview"
                        name="applicationsUnderReview"
                    />
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
